import axios from "../../utils/Axios";

export const updateJob = async (id, updatedValue) => {
    const response = await axios.patch(`/jobs/${id}`,updatedValue);
    return response.data;
}